import { PRODUCT_TAG_SOCIAL_SHARE } from '../../constants/product';
import { GeneratedGetProductsQuery } from '../../types/generated';
import { ProductPurchaseDetails } from '../../types/Purchasing';

type Props = {
  slug: string;
  api?: GeneratedGetProductsQuery['getProducts'][number];
  preview: boolean;
  shopify: ProductPurchaseDetails | null;
  storyblok: ProductType;
};

// render data mismatches when app is in preview mode to reduce operation errors
// should only be used to address shopify/storyblok limitations
// be careful not to "abuse" this
export const PreviewWarningProducts: React.FC<Props> = ({
  api,
  preview,
  shopify,
  slug,
  storyblok,
}) => {
  if (!preview) {
    return null;
  }

  const errs: string[] = [];

  const shopifySlug = shopify?.slug || api?.slug;
  if (shopifySlug && shopifySlug !== slug) {
    errs.push('shopify slug(handle) is not the same as storyblok');
  }

  // storyblok does not add default values for old published pages
  if (
    storyblok.checkoutSuccessImage?.filename &&
    !api?.tags.includes(PRODUCT_TAG_SOCIAL_SHARE)
  ) {
    errs.push(
      'checkout success image uploaded but missing "Social share" tag in shopify',
    );
  }

  if (
    !storyblok.checkoutSuccessImage?.filename &&
    api?.tags.includes(PRODUCT_TAG_SOCIAL_SHARE)
  ) {
    errs.push(
      'checkout success image is missing but Social share tag is added in shopify',
    );
  }

  if (!errs.length) {
    return null;
  }

  return (
    <div className="m-4 bg-danger-4 text-white">
      {errs.map((err, i) => (
        <div key={err} className="m-2">
          {i + 1}: {err}
        </div>
      ))}
    </div>
  );
};
